var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnbHistoryOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.4004 3.5H19.4004V1.5H17.4004V3.5H7.40039V1.5H5.40039V3.5H4.40039C3.30039 3.5 2.40039 4.4 2.40039 5.5V18.5C2.40039 19.6 3.30039 20.5 4.40039 20.5H20.4004C21.5004 20.5 22.4004 19.6 22.4004 18.5V5.5C22.4004 4.4 21.5004 3.5 20.4004 3.5ZM20.4004 18.5H4.40039V10.5H20.4004V18.5ZM20.4004 8.5H4.40039V5.5H20.4004V8.5Z",
    fill: "#00BF9D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnbHistoryOn);
export default __webpack_public_path__ + "static/media/gnb_history_on.3765f60f35a6086c5a54ff96bd207a25.svg";
export { ForwardRef as ReactComponent };